import { FALLBACK_LOCALE, formatReportDate } from 'utilities/i18n'

// Callers inside the report pass the locale-aware formatter from
// useReportTranslation(). Standalone callers (and tests) get English so the
// helper stays safe to call without wiring up the report i18n context.
const formatDateFallback = (date, { short = false } = {}) =>
  formatReportDate({ date, locale: FALLBACK_LOCALE, short })

export const formatDates = ({
  startDate,
  endDate,
  prevStartDate,
  prevEndDate,
  formatDate = formatDateFallback,
}) => ({
  startDate: formatDate(startDate, { short: true }),
  endDate: formatDate(endDate, { short: true }),
  prevStartDate: formatDate(prevStartDate, { short: true }),
  prevEndDate: formatDate(prevEndDate, { short: true }),
})
